/* eslint-disable react/jsx-no-target-blank */
import {useIntl} from 'react-intl'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import {isAuthorizedUser, userHasMainScope} from '../../../../../app/routing/utils/permissions'
import {useAuth} from '../../../../../app/modules/auth'

const SidebarMenuMain = () => {
  const intl = useIntl()

  const {currentUser} = useAuth()

  return (
    <>
      <SidebarMenuItem
        to='/dashboard'
        icon='home'
        title={intl.formatMessage({id: 'MENU.DASHBOARD'})}
        fontIcon='bi-app-indicator'
      />

      {userHasMainScope(currentUser, ['sales', 'budgets', 'billings']) && (
        <SidebarMenuItemWithSub to='/sales' title='Vendas' fontIcon='bi-archive' icon='wallet'>
          {isAuthorizedUser(currentUser, 'sales.view') && (
            <SidebarMenuItem to='/sales/list' title='Listar' hasBullet={true} />
          )}
          {(isAuthorizedUser(currentUser, 'sales.create') ||
            isAuthorizedUser(currentUser, 'budgets.create')) && (
            <SidebarMenuItem to='/sales/create' title='Realizar venda' hasBullet={true} />
          )}
          {isAuthorizedUser(currentUser, 'billings.view') && (
            <SidebarMenuItem to='/sales/billings' title='Cobranças' hasBullet={true} />
          )}
          {isAuthorizedUser(currentUser, 'budgets.view') && (
            <SidebarMenuItem to='/sales/budgets' title='Orçamentos' hasBullet={true} />
          )}
        </SidebarMenuItemWithSub>
      )}

      {userHasMainScope(currentUser, ['franchises']) && (
        <SidebarMenuItemWithSub
          to='/franchises'
          title='Franquias'
          fontIcon='bi-archive'
          icon='shop'
        >
          {isAuthorizedUser(currentUser, 'franchises.view') && (
            <SidebarMenuItem to='/franchises/list' title='Listar' hasBullet={true} />
          )}
          {isAuthorizedUser(currentUser, 'franchises.create') && (
            <SidebarMenuItem to='/franchises/create' title='Cadastrar' hasBullet={true} />
          )}
          {isAuthorizedUser(currentUser, 'franchiseInvoices.view') && (
            <SidebarMenuItem
              to='/franchises/franchiseInvoice'
              title='Listar Despesas'
              hasBullet={true}
            />
          )}
        </SidebarMenuItemWithSub>
      )}

      <SidebarMenuItem to='/schedules' title='Agenda' fontIcon='bi-archive' icon='calendar' />

      {userHasMainScope(currentUser, ['rooms']) && (
        <SidebarMenuItemWithSub
          to='/rooms'
          title='Salas'
          fontIcon='bi-archive'
          icon='lots-shopping'
        >
          {isAuthorizedUser(currentUser, 'rooms.view') && (
            <SidebarMenuItem to='/rooms/list' title='Listar' hasBullet={true} />
          )}
        </SidebarMenuItemWithSub>
      )}

      {userHasMainScope(currentUser, ['persons', 'medicalConditions', 'transfers']) && (
        <SidebarMenuItemWithSub
          to='/people'
          title='Clientes'
          fontIcon='bi-archive'
          icon='profile-user'
        >
          {isAuthorizedUser(currentUser, 'persons.view') && (
            <SidebarMenuItem to='/people/list' title='Listar' hasBullet={true} />
          )}
          {isAuthorizedUser(currentUser, 'medicalConditions.view') && (
            <SidebarMenuItem
              to='/people/medicalConditions'
              title='Condição Médica'
              hasBullet={true}
            />
          )}
          {isAuthorizedUser(currentUser, 'persons.create') && (
            <SidebarMenuItem to='/people/create' title='Criar Cliente' hasBullet={true} />
          )}

          {isAuthorizedUser(currentUser, 'persons.temporary_client') && (
            <SidebarMenuItem
              to='/clientTemporarily/list'
              title='Listar Temporário'
              hasBullet={true}
            />
          )}
        </SidebarMenuItemWithSub>
      )}

      {userHasMainScope(currentUser, ['users', 'groups']) && (
        <SidebarMenuItemWithSub
          to='/transfers'
          title='Transferências'
          fontIcon='bi-archive'
          icon='arrow-right-left'
        >
          {isAuthorizedUser(currentUser, 'users.view') && (
            <SidebarMenuItem to='/transfers/list' title='Listar Transferências' hasBullet={true} />
          )}
        </SidebarMenuItemWithSub>
      )}

      {userHasMainScope(currentUser, ['users']) && (
        <SidebarMenuItemWithSub to='/users' title='Usuários' fontIcon='bi-archive' icon='user'>
          {isAuthorizedUser(currentUser, 'users.view') && (
            <SidebarMenuItem to='/users/list' title='Listar Usuários' hasBullet={true} />
          )}
        </SidebarMenuItemWithSub>
      )}

      {userHasMainScope(currentUser, ['reports']) && (
        <SidebarMenuItemWithSub
          to='/reports'
          title='Relatórios'
          fontIcon='bi-archive'
          icon='graph-up'
        >
          {isAuthorizedUser(currentUser, 'reports.sales') && (
            <SidebarMenuItem to='reports/reportSale/list' title='Vendas' hasBullet={true} />
          )}
          {isAuthorizedUser(currentUser, 'reports.bonus_sales') && (
            <SidebarMenuItem
              to='reports/reportBonusSale/list'
              title='Vendas Bonus'
              hasBullet={true}
            />
          )}
          {isAuthorizedUser(currentUser, 'reports.salesman') && (
            <SidebarMenuItem to='reports/reportUser/list' title='Meta de Vendas' hasBullet={true} />
          )}
          {isAuthorizedUser(currentUser, 'reports.client_analytic') && (
            <SidebarMenuItem to='reports/reportMetric/list' title='Métricas' hasBullet={true} />
          )}
          {isAuthorizedUser(currentUser, 'reports.star_changes') && (
            <SidebarMenuItem
              to='reports/reportStarChanges/list'
              title='Troca de Estrelas'
              hasBullet={true}
            />
          )}
          {isAuthorizedUser(currentUser, 'reports.customers') && (
            <SidebarMenuItem to='reports/reportCliente/list' title='Clientes' hasBullet={true} />
          )}
          {isAuthorizedUser(currentUser, 'reports.transfers') && (
            <SidebarMenuItem
              to='reports/reportTransfer/list'
              title='Transferência'
              hasBullet={true}
            />
          )}
          {isAuthorizedUser(currentUser, 'reports.summary') && (
            <SidebarMenuItem to='reports/reportSummary/list' title='Resumo' hasBullet={true} />
          )}
          {isAuthorizedUser(currentUser, 'reports.recurrence') && (
            <SidebarMenuItem
              to='reports/reportRecurrence/list'
              title='Recorrência'
              hasBullet={true}
            />
          )}
          {isAuthorizedUser(currentUser, 'reports.export') && (
            <SidebarMenuItem to='reports/downloads' title='Downloads' hasBullet={true} />
          )}
        </SidebarMenuItemWithSub>
      )}
    </>
  )
}

export {SidebarMenuMain}
